import { getContext } from '@fiverr-private/fiverr_context';
import { useAttachments } from '../../context/contexts/attachments';
import { useStaticContext } from '../../context/contexts/static';
import { shouldShowMoreGigs, shouldShowMoreGigsV4 } from '../../utils/moreGigs';
import { useRemoteDate } from '..';

/**
 * returns object whether the offer more gigs step should be shown for v3 and v4
 *
 * @returns {{shouldShowMoreGigsV3: boolean, shouldShowMoreGigsV4: boolean}}
 */
const useShouldOfferMoreGigs = () => {
    const { subCategoryId, recipientInfo, senderInfo, offerMoreGigsEnabled } = useStaticContext();
    const { attachments } = useAttachments();
    const { utcOffset, isOnline } = recipientInfo;
    const { isNight } = useRemoteDate({ utcOffset });
    const { country } = getContext();
    const { isRnc } = senderInfo;

    return {
        shouldShowMoreGigsV3: offerMoreGigsEnabled && shouldShowMoreGigs({ attachments, subCategoryId, isNight, isOnline, isRnc }),
        shouldShowMoreGigsV4: offerMoreGigsEnabled && shouldShowMoreGigsV4({ attachments, isRnc, isOnline, country })
    };
};

export default useShouldOfferMoreGigs;
